import { render, staticRenderFns } from "./TaskSummaryAssignment.vue?vue&type=template&id=39524c19"
import script from "./TaskSummaryAssignment.vue?vue&type=script&lang=js"
export * from "./TaskSummaryAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports